import { render, staticRenderFns } from "./FileUploaderTransparent2.vue?vue&type=template&id=53f260aa&scoped=true"
import script from "./FileUploaderTransparent2.vue?vue&type=script&lang=js"
export * from "./FileUploaderTransparent2.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderTransparent2.vue?vue&type=style&index=0&id=53f260aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f260aa",
  null
  
)

export default component.exports